<div mat-dialog-content>
  <div class="mt-3">
    <h3>Confirmar descadastro do cliente? Ao clicar em <b>"SIM"</b> você confirma que o cliente não deseja mais receber
      ativações da equipe de vendas?</h3>
    <button (click)="descadastrarCliente()" class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-cancel-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()">sim
    </button>
    <button (click)="close()" class="btn btn-block btn-azul mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()">não
    </button>
  </div>
</div>
